// Narrows to a plain object — excludes arrays (and null), unlike isObject. Use when array values must be
// treated as leaves rather than recursed into.
export const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)
